var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"lg":"2","md":"3","sm":"12","xs":"12"}},[_c('sider-menu-items',{attrs:{"element":_vm.element}},[_vm._v("<")])],1),_c('b-col',{attrs:{"lg":"10","md":"9","sm":"12","xs":"12"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }